import { render } from "./ArticleView.vue?vue&type=template&id=7ba68772&scoped=true&ts=true"
import script from "./ArticleView.vue?vue&type=script&lang=ts"
export * from "./ArticleView.vue?vue&type=script&lang=ts"

import "./ArticleView.vue?vue&type=style&index=0&id=7ba68772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba68772"]])

export default __exports__